<template>
  <header :class="['header', 'panel', _isMobile() ? 'mobile' : '']">
    <div class="logo-bar" :class="[menuActive == '首页' ? 'homeHeader':'']">
      <a-row type="flex" justify="space-between" class="menu-up">
        <a-col :span="4">
          <div class="logo">
            <img :src="logo ? logo : '/img/logo.png'" alt=""/>
          </div>
        </a-col>
        <a-col :span="12">
          <div
            :class="['menu-bar', showMenu ? 'show' : 'hide', menuFixed?'menu-fixed':'']"
            @mouseleave="leave"
            @mouseover="over"
          >
          <t-menu class="menu" mode="horizontal" :menu="menus"></t-menu>
          </div>

        </a-col>
        <a-col  :span="4">
          <div class="share-code">
            <a-input-search
                v-model="shareCode"
                placeholder="输入分享码一键跳转"
                @search="onSearch"
            />
          </div>
        </a-col>
        <a-col :span="4">
          <div class="login-btn-wrap">
           
            <span v-if="$store.state.user.info">
              欢迎，<span  @click="toCenter" style="padding-right: 10px;font-weight: bold;">{{ $store.state.user.info.realname }}</span>
              <a-avatar v-if="$store.state.user.info"  @click="toCenter" icon="user" :src="avatarUrl" />
              <a-divider type="vertical" />
              <span @click="handleLogout">退出</span>
            </span>
            <span v-else>
              <span @click="toLogin">登录</span>
              <a-divider v-if="tenantInfo.allowReg=='1' || tenantInfo.allowReg=='2' " type="vertical" />
              <span v-if="tenantInfo.allowReg=='1' || tenantInfo.allowReg=='2'" @click="toRegister">注册</span>
            </span>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="float-menu">
          <div class="float-button" @click="scrollToTop" style="margin-bottom: 12px;">
            <i class="iconfont" style="font-size: 40px;padding-bottom: 10px;">&#xe6ab;</i>
            <div>回到顶部</div>
          </div>
          <div class="float-button" @click="AIChatStatus=true">
            <i class="iconfont" style="font-size: 28px;padding-bottom: 10px;">&#xe60a;</i>
            <div>AI助手</div>
          </div>
    </div>
    <AIChat v-if="AIChatStatus" @closeFn="AIChatStatus=false" />
  </header>
</template>
<script>
import Vue from "vue";
import { ACCESS_TOKEN,SYSTEM_INFO } from "@/store/mutation-types";
import { mapActions } from "vuex";
import { mixinDevice } from "@/utils/mixin.js";
import TMenu from "@/components/menu"
import { jumpMixins } from "@/utils/jumpMixins"
import { putAction, postAction, getAction } from "@/api/manage";
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'
import AIChat from '@/components/tools/AIChat.vue';
export default {
  name: "Header",
  mixins: [mixinDevice, jumpMixins],
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TMenu,
    AIChat
  },
  data() {
    return {
      AIChatStatus:false,
      showLogin: false,
      showRegister: false,
      showMenu: true,
      logo: "",
      token: "",
      menus: [],
      menuFixed: false,
      menuActive:'首页',
      tenantInfo: {},
      shareCode: ""
    };
  },
  watch:{
    '$route'(to, from) {
      this.menuActive = to.meta.title
    },
  },
  created() {
    if(this.$route.query.shareCode){
      this.onSearch(this.$route.query.shareCode)
    }
    this.menuActive = this.$route.meta.title
    this.token = Vue.ls.get(ACCESS_TOKEN);
    this.tenantInfo = this.$store.getters.tenantInfo
    let systemInfo = Vue.ls.get(SYSTEM_INFO)
    this.logo = systemInfo&&systemInfo.schoolLogo ? systemInfo.schoolLogo : this.tenantInfo.logo2
    this.menus = this.$store.getters.menuList
  },
  computed:{
    avatarUrl(){
      if(this.$store.state.user.avatar){
        return this.$store.state.user.avatar
      }else if(this.$store.state.user.info && this.$store.state.user.info.avatar){
        return this.$store.state.user.info.avatar
      }else{
        return "/img/avatar.png"
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    ...mapActions(["Logout"]),
    toCenter(){
      this.$router.push("/classroom/home")
    },
    onSearch(v) {
      if(!v) return
      let params = {id:v};
      getAction('/teaching/teachingSharingCode/queryByCodeId',params).then(res=>{
        if (res.success){
          window.open(res.result)
        }else {
          this.$message.error(res.message)
        }
      });
      console.log(v);

    },
    leave() {
      if (this.autoHide) this.showMenu = false;
    },
    over() {
      if (this.autoHide) this.showMenu = true;
    },
    openPageFn(title){
      console.log(title , 'title')
      // this.$set(this,'menuActive',title)
    },
    handleScroll(){
      // let scrollTop = document.documentElement.scrollTop
      // if (scrollTop >= 105) {
      //   this.menuFixed = true
      // } else {
      //   this.menuFixed = false
      // }
    },
    loginSuccess() {
      this.showLogin = false;
      this.userInfo = this.$store.state.user.info;
    },
    regSuccess() {
      this.showRegister = false;
      this.showLogin = true;
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              that.$router.push({name:'index'})
              window.location.reload()
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 平滑滚动效果
      });
    }
  },
};
</script>
<style lang="less" scoped>
.menu-bar {
  width: 100%;
  z-index: 999;
  .menu {
    background: transparent;
    max-width: 1200px;
    margin: auto;
    /deep/.ant-menu-item .anticon{
      display: none;
    }
    /deep/.ant-menu-item,/deep/.ant-menu-submenu{
      margin: 0 8px;
      border-radius: 5px;
      line-height: 30px;
      
    }
    /deep/.ant-menu-item:hover,/deep/.ant-menu-submenu:hover{
      background: #fff;
      border-radius: 5px;
    }
    /deep/.ant-menu-overflowed-submenu{
      margin: unset;
      border: unset;
    }
    .ant-menu-submenu,
    /deep/.ant-menu-item > a, /deep/.ant-menu-submenu-title > a {
      font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
      font-weight: 600;
      font-size: 16px;
      color: white;
    }
    /deep/.ant-menu-item > a:hover, /deep/.ant-menu-submenu-title > a:hover{
      color: rgb(36, 114, 251)
    }
    .ant-menu-submenu-active,
    .ant-menu-item-active {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 15px;
      border-bottom: none !important;
    }
  }
  .ant-menu-horizontal {
    border-bottom:none;
  }
}
.homeHeader{
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #33333344 !important;

}
.hide {
  height: 50px;
  background-color: transparent !important;
  transition: all 0.1s ease;
}

.logo-bar {
  z-index: 99;
  background: rgb(36, 114, 251);
  // border-bottom: 1px solid #f5f7fa;
  .menu-up {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    // height: 80px;
    .logo {
      margin-top: 5px;
      margin-right: 10px;
      img {
        display: inline-block;
        height: 50px;
        margin: 0 !important;
      }
      h2 {
        display: inline;
        font-style: italic;
        font-size: 20px;
        color: #ffffff;
        line-height: 30px;
        text-shadow: #b3b0b0ab 5px 3px 5px;
      }
    }
    .share-code{
      height: 100%;
      display: flex;
      align-items: center;
    }
    .login-btn-wrap {
      cursor: pointer;
      height: 100%;
      text-align: right;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: end;
      /deep/.ant-input{
        background-color: transparent;
        color: white;
      }
      /deep/.ant-input-suffix{
        i{
          color: rgba(255, 255, 255, 0.82);
        }
      }
      .ant-avatar {
        margin-right: 5px;
      }
      span {
        color: #fff;
      }
      .help {
        color: gray;
      }
    }
  }
}

</style>